import { render, staticRenderFns } from "./bubble-msg.vue?vue&type=template&id=69ef3b7a&scoped=true"
import script from "./bubble-msg.vue?vue&type=script&lang=js"
export * from "./bubble-msg.vue?vue&type=script&lang=js"
import style0 from "./bubble-msg.vue?vue&type=style&index=0&id=69ef3b7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ef3b7a",
  null
  
)

export default component.exports